import type * as React from 'react';
import { get } from '@Domain/Api';
import workingFacilityCountsFetched, {
	type WorkingFacilityCountsFetchedAction,
} from '@Application/Indicators/WorkingFacility/Actions/workingFacilityCountsFetched';
import workingFacilityCountsFetchFailed, {
	type WorkingFacilityCountsFetchFailedAction,
} from '@Application/Indicators/WorkingFacility/Actions/workingFacilityCountsFetchFailed';
import type FetchWorkingFacilityCounts from '@Application/Indicators/WorkingFacility/Queries/FetchWorkingFacilityCounts';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = WorkingFacilityCountsFetchedAction | WorkingFacilityCountsFetchFailedAction;

type CountResponse = { totalRecords: number };

/**
 * Reads only `totalRecords` of a one-row page; nothing is dispatched to the workflow-run store,
 * whose list is filtered and paginated by its own screen.
 */
export default (query: FetchWorkingFacilityCounts) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const runs = query.includeWatchedRuns
				? await get<CountResponse>(
						`${parameters.api.host}/api/facilities/${query.facilityId}/workflow-runs?status=watch&rows=1`,
					)
				: null;

			const action = workingFacilityCountsFetched({
				facilityId: query.facilityId,
				watchedRuns: runs?.totalRecords ?? null,
			});
			dispatch(action);
			return action;
		} catch (error) {
			const action = workingFacilityCountsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
